import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Resources from "@/pages/Resources";

export const Route = createFileRoute("/en/knowledge-center/")({
  head: () => buildRouteHead("/en/knowledge-center"),
  component: Resources,
});
